<div class="text-center">
  <h1 class="h5 text-uppercase">{{ 'auth.two-factor.challenge.heading' | translate }}</h1>

  <p class="my-4">
    {{ 'auth.two-factor.challenge.paragraph_one' | translate }}
  </p>

  <p class="my-4">
    {{ 'auth.two-factor.challenge.paragraph_two' | translate }}
  </p>
</div>

<div class="row mt-2">
  <app-form-group
    [formControl]="form.controls.code"
    type="text"
    name="code"
    label="{{ 'auth.two-factor.challenge.form.code.label' | translate }}"
    [errorMessages]="{required: ('auth.two-factor.challenge.form.code.validation_messages.required' | translate)}"
  ></app-form-group>
</div>

<div class="row mt-3">
  <div class="col-12">
    <button (click)="submit()" type="submit" class="btn btn-primary w-100">{{ 'auth.two-factor.challenge.form.submit_btn' | translate }}</button>
  </div>
</div>
